// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__26tA_","itemTitle":"ClientEmergencyInfo_itemTitle__1ECpZ","itemText":"ClientEmergencyInfo_itemText__2Nyxn"};